import { FC } from 'react'
import { SwaggerRoutes } from '../types'
import { AccordionTagGroup } from './AccordionTagGroup'

interface AccordionTypeGroupProps {
  routeType: string
  tagGroups: Record<string, SwaggerRoutes[]>
  isExpanded: boolean
  isFullySelected: boolean
  isPartiallySelected: boolean
  selectedPermissions: number[]
  expandedTags: Set<string>
  onToggleType: (routeType: string) => void
  onSelectAllType: (routeType: string) => void
  onToggleTag: (routeType: string, tag: string) => void
  onSelectAllTag: (routeType: string, tag: string) => void
  onToggleRoute: (routeId: number) => void
  isTagFullySelected: (routeType: string, tag: string) => boolean
  isTagPartiallySelected: (routeType: string, tag: string) => boolean
  getMethodColor: (method: string) => string
  getTypeLabel: (type: string) => string
}

export const AccordionTypeGroup: FC<AccordionTypeGroupProps> = ({
  routeType,
  tagGroups,
  isExpanded,
  isFullySelected,
  isPartiallySelected,
  selectedPermissions,
  expandedTags,
  onToggleType,
  onSelectAllType,
  onToggleTag,
  onSelectAllTag,
  onToggleRoute,
  isTagFullySelected,
  isTagPartiallySelected,
  getMethodColor,
  getTypeLabel,
}) => {
  const typeRouteCount = Object.values(tagGroups).reduce(
    (sum, routes) => sum + routes.length,
    0
  )

  return (
    <div className='accordion-item'>
      <h2 className='accordion-header'>
        <button
          className='accordion-button d-flex align-items-center justify-content-between'
          type='button'
          onClick={() => onToggleType(routeType)}
          style={{
            backgroundColor: isExpanded ? '#f8f9fa' : 'white',
          }}
        >
          <div className='d-flex align-items-center gap-2 flex-grow-1'>
            <span className='badge bg-secondary'>{typeRouteCount}</span>
            <strong>{getTypeLabel(routeType)}</strong>
            {isFullySelected && (
              <i className='fas fa-check-circle text-success ms-2'></i>
            )}
            {isPartiallySelected && (
              <i className='fas fa-minus-circle text-warning ms-2'></i>
            )}
            {!isFullySelected && !isPartiallySelected && (
              <i className='far fa-circle text-muted ms-2'></i>
            )}  
          </div>
        </button>
      </h2>

      {isExpanded && (
        <div className='accordion-body p-0'>
          {/* Type Level Select/Deselect Button */}
          <div className='p-3 border-bottom bg-light'>
            <button
              className='btn btn-info btn-sm'
              onClick={() => onSelectAllType(routeType)}
            >
              {isFullySelected ? 'Desselecionar Tipo' : 'Selecionar Tipo'}
            </button>
          </div>

          {/* Tags Accordion */}
          <div className='accordion' id={`accordion-${routeType}`}>
            {Object.entries(tagGroups).map(([tag, routes]) => {
              const tagKey = `${routeType}-${tag}`
              const tagExpanded = expandedTags.has(tagKey)

              return (
                <AccordionTagGroup
                  key={tag}
                  routeType={routeType}
                  tag={tag}
                  routes={routes}
                  isExpanded={tagExpanded}
                  isFullySelected={isTagFullySelected(routeType, tag)}
                  isPartiallySelected={isTagPartiallySelected(routeType, tag)}
                  selectedPermissions={selectedPermissions}
                  onToggleTag={onToggleTag}
                  onSelectAllTag={onSelectAllTag}
                  onToggleRoute={onToggleRoute}
                  getMethodColor={getMethodColor}
                />
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
